module.exports = __webpack_public_path__ + "img/mic-off.61a9c8f5.png";